import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { DataCardInterface } from '../components/utils/models/data-card-interface';

@Pipe({
  name: 'formatDataValue'
})
export class FormatDataValuePipe implements PipeTransform {

  transform(data: DataCardInterface): string {
    switch (data.type) {
      case "currency":
        return data.value.toLocaleString('en-ZA', {
          style: 'currency', 
          currency: 'ZAR',
          minimumFractionDigits: 0
        })
      case "number":
      default:
        return data.value.toString();
    }
  }

}

@NgModule({
  imports: [],
  providers: [],
  exports: [FormatDataValuePipe],
  declarations: [FormatDataValuePipe],
})
export class FormatDataValuePipeModule { }
